/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Tag
} from "antd";
import { format } from "date-fns";
import BoxUi from "@components/common/BoxUi";
import { createClientePotencial } from "@redux/slices/clientePotencial";
import { getCatalogos } from "@redux/slices/catalogos";
import { useDispatch, useSelector } from "@redux/store";
import { VALIDATE_MESSAGES } from "@theme/constants";

const ClienteForm = () => {
  const [form] = Form.useForm();
  const { simulacion } = useSelector(state => state.simulacion);
  const { cantones } = useSelector(state => state.catalogos);
  //SAVE CLIENTE POTENCIAL
  const dispatch = useDispatch();
  const clientePotencialState = useSelector(state => state.clientePotencial);

  const rules = {
    nombres: [
      {
        required: true,
        message: "Su nombre es obligatorio"
      }
    ],
    telefono: [
      {
        required: true,
        message: "Debe ingresar un número telefónico"
      }, {
        min: 10,
        message: "Debe tener mínimo 10 números"
      }, {
        max: 15,
        message: "No puede haber más de 15 números"
      }, {
        pattern: /^[0-9]+$/,
        message: "Solo se permiten números"
      }
    ],
    correo: [
      {
        required: true
      }, {
        type: "email",
        message: "Debe ingresar un correo electrónico válido"
      }
    ],
    tiempoInvertir: [
      {
        required: true,
        message: "Debe seleccionar una opción"
      }
    ],
    ciudadResidencia: [
      {
        required: true,
        message: "Debe seleccionar una ciudad"
      }
    ],
    mensaje: [
      {
        required: true,
        message: "Debe ingresar un mensaje"
      }
    ]
  };

  //OPCIONES DE HORARIOS
  const today = new Date();
  const optionsPlain = [
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19
  ];
  const options = optionsPlain.map(item => {
    const date = today.setHours(item, 0, 0, 0);
    return {
      key: item,
      value: format(date, "h:mm a")
    };
  });
  // const onHorariosChange = (value) => {
  //      (`selected ${value}`);
  // };
  // const onHorariosSearch = (value) => {
  //      ('search:', value);
  // };

  const router = useRouter();

  const onSaved = ({ nombres }) => {
    Modal.info({
      content: `${nombres}!  Gracias por compartir tus datos, pronto nos contactaremos contigo`,
      onOk() {
        router.push("/inversion/");
      }
    });
  };

  const onFinish = values => {
    // ANALYTICS EVENT
    handlerFunctionMetricsAnalytics(); // for google analytics
    console.log("Received values of form: ", values);
    dispatch(createClientePotencial(values, () => onSaved(values)));
  };

  useEffect(() => {
    dispatch(getCatalogos());
    form.setFieldsValue({ hash: simulacion.hash });
  }, []);

  console.log({ cantones });

  return (<BoxUi background="background">
    <Form form={form} layout="vertical" validateMessages={VALIDATE_MESSAGES} onFinish={onFinish} onFinishFailed={() => { }}>
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card title="Déjanos tus datos, para ponernos en contacto." extra={<Tag color="lime" > {
            simulacion.hash
          }
          </Tag>}>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Form.Item label="hash" name="hash" hidden="hidden">
                  <Input placeholder="hash" name="hash" size="large" />
                </Form.Item>
                <Form.Item label="¿Cuál es tu nombre?" name="nombres" rules={rules.nombres}>
                  <Input placeholder="nombres y apellidos" name="nombres" size="large" />
                </Form.Item>

                <Form.Item label="Teléfono" name="telefono" rules={rules.telefono}>
                  <Input placeholder="ceular/móvil o convencional" size="large" onKeyDown={e => {
                    if (e.key.match(/[^0-9]/g) && e.key !== "Backspace" && e.key !== "ArrowLeft" && e.key !== "ArrowRight")
                      e.preventDefault();
                  }} />
                </Form.Item>

                <Form.Item label="Correo" name="correo" rules={rules.correo}>
                  <Input placeholder="mail@mail.com" type="email" size="large" />
                </Form.Item>

                {/* TODO: MODIFIC THIS */}
                <Form.Item label="¿A qué tiempo deseas invertir?" name="tiempoInvertir" rules={rules.tiempoInvertir}>
                  <Select placeholder="Seleccione una opción" optionFilterProp="children"
                  // filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  >
                    <Select.Option value="90 días">90 días</Select.Option>
                    <Select.Option value="180 días">180 días</Select.Option>
                    <Select.Option value="370 días">370 días</Select.Option>
                    <Select.Option value="Más de 370 días">
                      Más de 370 días
                    </Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Ciudad de residencia" name="ciudadResidencia" rules={rules.ciudadResidencia}>
                  <Select showSearch="showSearch" placeholder="Seleccione una ciudad" optionFilterProp="children"
                    // onChange={onHorariosChange}

                    // onSearch={onHorariosChange}
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
                    {
                      [...cantones]?.sort((a, b) => a.contenido.localeCompare(b.contenido))
                        .map((value, key) => (<Select.Option value={value.contenido} key={key}>
                          {value.contenido}
                        </Select.Option>))
                    }
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="Mensaje" name="mensaje" rules={rules.mensaje}>
                  <Input.TextArea showCount="showCount" maxLength={100} onChange={e => e} style={{
                    height: "18em"
                  }} autoSize={{
                    minRows: 16,
                    maxRows: 16
                  }} />
                </Form.Item>
                <Button type="primary" size="large" htmlType="submit" style={{
                  width: "42em",
                  maxWidth: "100%"
                }} loading={clientePotencialState.loading}>
                  Enviar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </BoxUi>);
};

export default ClienteForm;